import { SearchSelect, SearchSelectProps } from './SearchSelect';
import { StandardSelect } from './StandardSelect';

// 171932 rename select
export const NewSelect = ({ search, ...rest }: SearchSelectProps & { search?: boolean }) => {
  return search ? <SearchSelect {...rest} /> : <StandardSelect {...rest} />;
};
